import { h } from "preact";
import { Loader } from "semantic-ui-react";

import styles from "./UserDashboard.scss";
import UserRow from "./UserRow";

const UserDashboard = ({ dashboardData, searchQuery }) => {
  if (!dashboardData) {
    return (
      <Loader active indeterminate>
        Loading Dashboard
      </Loader>
    );
  }
  return (
    <div className={styles.item}>
      <div className={styles.userMoods}>
        {dashboardData
          .filter(
            user =>
              user.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
              user.first_name
                .toLowerCase()
                .includes(searchQuery.toLowerCase()) ||
              user.last_name.toLowerCase().includes(searchQuery.toLowerCase())
          )
          .map(user => (
            <UserRow user={user} visible key={user.id} />
          ))}
      </div>
    </div>
  );
};

export default UserDashboard;



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/UserDashboard.js